type I18n = {
    gettext: (key: string, params?: string[]) => string;
};

const REMOTE_INLINE_SUIDS = ['DSQF7', 'PAXZC', 'VAMUB'];

export function getLocationText(
    locationLong: string,
    i18n: I18n,
    attributes?: Array<{ key: string; label: string | null }> | null,
): string {
    if (locationLong && attributes) {
        const remoteAttr = attributes.find((attr) => REMOTE_INLINE_SUIDS.includes(attr.key));
        if (remoteAttr?.label) {
            return i18n.gettext('{0} in {1}', [remoteAttr.label, locationLong]);
        }
    }
    return locationLong;
}
